export default __webpack_public_path__ + "static/media/icon-umwelt-co-2-einsparung-wei.97b14e97.svg";